import { FC } from 'react';

import './Preloader.scss';

const Preloader: FC = () => {
  return <div className="preloader" />;
};

export { Preloader };
